import './HeatingSettings.css';
import NumericInput from './NumericInput.js';
import React from 'react';
import { t } from './i18n.js';

export function ConsumptionControlTable({ services, metadata, onToggleEnabled, onControlToggle, onOverrideToggle, onFixedRulesChange, onOverrideHoursChange, onOverrideTypeChange, onRulesArrayChange, onSlotChange, onCurrentAChange }) {
  if (!services || services.length === 0) {
    return <div>{t('consumption.noServices')}</div>;
  }

  if (!metadata) {
    return <div>{t('consumption.missingMetadata')}</div>;
  }

  const { rank_types, override_types } = metadata;

  return (
    <div className="profile-tables-container">
      {services.map((service) => (
        <div key={service.id} className="profile-table">
          <h3>{service.name}</h3>
          
          <div style={{ marginBottom: '15px' }}>
            <label style={{ marginRight: '20px' }}>
              {t('common.enabled')}:
              <input
                type="checkbox"
                checked={service.enabled}
                onChange={(e) => onToggleEnabled(service.id, 'enabled', e.target.checked)}
                style={{ marginLeft: '8px' }}
              />
            </label>
            <span>{t('consumption.actorName')}: {service.actor_name}</span>
          </div>
          
    
          {/* Control Settings */}
          <table className="profile-table">
            <thead>
              <tr>
                <th colSpan="2">{t('consumption.controlSettings')}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{t('common.enabled')}</td>
                <td>
                  <input
                    type="checkbox"
                    checked={service.controller.enabled}
                    onChange={(e) => onControlToggle(service.id, e.target.checked)}
                  />
                </td>
              </tr>
              <tr>
                <td>{t('consumption.activePeriod')}</td>
                <td>{rank_types[service.controller.rank_type]}</td>
              </tr>
                {service.actor && service.actor.currentA !== undefined && (
                  <tr>
                        <td>{t('consumption.maxCurrent')}</td>
                        <td>
                          <NumericInput
                            value={service.actor.currentA}
                            onChange={(value) => onCurrentAChange(service.id, value)}
                            min={0}
                            max={32}
                            step={1}
                          />
                        </td>
                    </tr>
                )}
              <tr>
                <td>
                  {service.controller.type === 'fixed_hours'
                    ? t('consumption.enableHours')
                    : service.controller.type === '6h_slot'
                    ? t('consumption.timeWindow')
                    : t('consumption.ranges')}
                </td>
                <td>
                  {service.controller.type === 'fixed_hours' ? (
                    <NumericInput
                      value={service.controller.rules}
                      onChange={(value) => onFixedRulesChange(service.id, 'controller', value)}
                      min={0}
                      max={24}
                      step={1}
                    />
                  ) : service.controller.type === '6h_slot' ? (
                    <span>{t('consumption.slots')}</span>
                  ) : (
                    <span>{t('consumption.enableHours')}</span>
                  )}
                </td>
              </tr>
              
              {service.controller.type === 'price_based' && Array.isArray(service.controller.rules) && (
                <>
                  {service.controller.rules.map((priceConfig, index) => (
                    <tr key={`price-range-${index}`}>
                      <td>
                        {priceConfig.max_price === 999
                          ? `> ${service.controller.rules[index - 1]?.max_price || 0} c/kWh`
                          : index === 0
                            ? `≤ ${priceConfig.max_price} c/kWh`
                            : `${service.controller.rules[index - 1]?.max_price} - ${priceConfig.max_price} c/kWh`
                        }
                      </td>
                      <td>
                        <NumericInput
                          value={priceConfig.hours}
                          onChange={(value) => onRulesArrayChange(service.id, index, value)}
                          min={0}
                          max={24}
                          step={1}
                        />
                      </td>
                    </tr>
                  ))}
                </>
              )}

              {service.controller.type === 'temperature_based' && Array.isArray(service.controller.rules) && (
                <>
                  {service.controller.rules.map((tempConfig, index) => (
                    <tr key={`temp-range-${index}`}>
                      <td>
                        {tempConfig.max_temp === 100
                          ? ` > ${service.controller.rules[index - 1]?.max_temp || 0} \u00b0C`
                          : index === 0
                            ? ` ≤ ${tempConfig.max_temp} \u00b0C`
                            : `  ${service.controller.rules[index - 1]?.max_temp} - ${tempConfig.max_temp} \u00b0C`
                        }
                      </td>
                      <td>
                        <NumericInput
                          value={tempConfig.hours}
                          onChange={(value) => onRulesArrayChange(service.id, index, value)}
                          min={0}
                          max={24}
                          step={1}
                        />
                      </td>
                    </tr>
                  ))}
                </>
              )}


              {service.controller.type === 'scheme_based' && Array.isArray(service.controller.rules) && (
                <>
                  {service.controller.rules.map((schemeConfig, index) => (
                    <tr key={`scheme-range-${index}`}>
                      <td>
                        {schemeConfig.name}
                      </td>
                      <td>
                        <NumericInput
                          value={schemeConfig.hours}
                          onChange={(value) => onRulesArrayChange(service.id, index, value)}
                          min={0}
                          max={24}
                          step={1}
                        />
                      </td>
                    </tr>
                  ))}
                </>
              )}

              {service.controller.type === '6h_slot' && service.controller.rules && typeof service.controller.rules === 'object' && !Array.isArray(service.controller.rules) && (
                <>
                  {Object.entries(service.controller.rules)
                    .sort(([a], [b]) => a.localeCompare(b))
                    .map(([timeWindow, slots]) => (
                      <tr key={`slot-${timeWindow}`}>
                        <td>{timeWindow}</td>
                        <td>
                          <NumericInput
                            value={slots}
                            onChange={(value) => onSlotChange(service.id, timeWindow, value)}
                            min={0}
                            max={24}
                            step={1}
                          />
                        </td>
                      </tr>
                    ))}
                </>
              )}

            </tbody>
          </table>
          
          {/* Override Settings */}
          <table className="profile-table" style={{ marginTop: '0px' }}>
            <thead>
              <tr>
                <th colSpan="3">{t('consumption.overrideSettings')}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{t('common.enabled')}</td>
                <td colSpan="2">
                  <input
                    type="checkbox"
                    checked={service.override.enabled}
                    onChange={(e) => onOverrideToggle(service.id, e.target.checked)}
                  />
                </td>
              </tr>
              <tr>
                <td>{t('consumption.overrideType')}</td>
                <td>
                  <select 
                    value={service.override.type}
                    onChange={(e) => onOverrideTypeChange(service.id, e.target.value)}
                  >
                    {Object.entries(override_types).map(([type, label]) => (
                      <option key={type} value={type}>
                        {label}
                      </option>
                    ))}
                  </select>
                </td>
                <td>
                  {service.override.type === 'until_end_of_day' ? (
                    <span className="inactive-field">{t('consumption.notApplicable')}</span>
                  ) : (
                    <NumericInput
                      value={service.override.hours}
                      onChange={(value) => onOverrideHoursChange(service.id, value)}
                      min={0}
                      max={24}
                      step={1}
                    />
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
}
